/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { InputChip } from 'components/Fields';

const StampColor = () => {
  return <InputChip type="STAMP_COLOR" name="stampColor" label="Stamp color" />;
};

export default StampColor;
